import { getFatigueDetailsForLevel } from './getFatigueDetails'

function normaliseFatigueLevel(level) {
  if (typeof level !== 'string') {
    return 'Fresh'
  }

  const normalized = level.trim().toLowerCase()

  switch (normalized) {
    case 'debilitated':
      return 'Debilitated'
    case 'exhausted':
      return 'Exhausted'
    case 'wearied':
      return 'Wearied'
    case 'tired':
      return 'Tired'
    case 'winded':
      return 'Winded'
    default:
      return 'Fresh'
  }
}

export default function calcCombatantDexFromFatigue({
  existing_dex,
  existing_fatigue_str,
  new_fatigue_level,
}) {
  if (typeof existing_dex !== 'number' || Number.isNaN(existing_dex)) {
    return existing_dex
  }

  const existingFatigueDetails = getFatigueDetailsForLevel(
    normaliseFatigueLevel(existing_fatigue_str),
  )
  const newFatigueDetails = getFatigueDetailsForLevel(normaliseFatigueLevel(new_fatigue_level))

  const baselineDex = existing_dex - (Number(existingFatigueDetails?.adj_dex) || 0)
  const nextDex = baselineDex + (Number(newFatigueDetails?.adj_dex) || 0)

  return Math.max(1, nextDex)
}
